import { useCallback, useEffect, useState } from 'react';

import type { RegisterSection, SectionId } from '../model/operations';
import { useCustomizationDispatch } from '../state/useCustomizationDispatch';
import { createScrollAdapter } from './scrollAdapter';

export type SectionScrollNavigation = {
  registerSection: RegisterSection;
  handleSectionSelect: (sectionId: SectionId) => void;
};

export function useSectionScrollNavigation(
  sectionIds: SectionId[]
): SectionScrollNavigation {
  const dispatch = useCustomizationDispatch();
  const [adapter] = useState(createScrollAdapter);

  useEffect(() => () => adapter.dispose(), [adapter]);

  useEffect(
    () =>
      adapter.observeSections(sectionIds, sectionId => {
        dispatch({ type: 'ACTIVE_SECTION_SET', sectionId });
      }),
    [adapter, sectionIds, dispatch]
  );

  const handleSectionSelect = useCallback(
    (sectionId: SectionId) => {
      dispatch({ type: 'ACTIVE_SECTION_SET', sectionId });
      adapter.scrollToSection(sectionId);
    },
    [adapter, dispatch]
  );

  return { registerSection: adapter.registerSection, handleSectionSelect };
}
